import React from "react";
import { useEffect } from "react";
import DashboardTugas from "../../src/components/Dashboard/DashboardTugas";

const DashboardPetugas = () => {
  useEffect(() => {
    document.title = "Si TASIK - Dashboard";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="p-6">
      <DashboardTugas/>
    </div>
  );
};

export default DashboardPetugas;
